const React = require('react')
const { Navbar, NavbarBrand, Container } = require('reactstrap')
const { useState, useEffect } = require('react')
const { useParams, useLocation, useHistory } = require('react-router-dom')
const { useNetworkConfig } = require('@contexts')
const { useResponsive, BREAKPOINTS } = require('@hooks')

const { SearchBox } = require('./searchBox.header')
const { HeaderDropdown } = require('./dropdown.header')
const { HeaderDropdownNetworks } = require('./dropdownNetworks.header')
const { MobileMenu } = require('./mobile/mobileMenu')

require('@styles/layouts/header/index.css')

const Header = () => {
    const params = useParams()
    const history = useHistory()
    const location = useLocation()
    const { switchNetwork, network } = useNetworkConfig()
    const currentNetwork = params.network || network.name
    const [showSearch, setShowSearch] = useState(false)
    const isMobile = useResponsive(BREAKPOINTS.extraLarge)

    if (params.network && network.name !== currentNetwork) {
        switchNetwork(currentNetwork)
    }

    const isBlockchain_1 = network.data.type === 'Ethereum 1.0'
    const isBlockchain_2 = network.data.type === 'Ethereum 2.0'

    useEffect(() => {
        const isHomePage = location.pathname === '/' || location.pathname === `/${network.data.shortName}`

        if (!isHomePage) {
            setShowSearch(!isMobile)
            return
        }

        const handleScroll = () => {
            if (window.scrollY > 150 && !isMobile) {
                setShowSearch(true)
            } else {
                setShowSearch(false)
            }
        }

        window.addEventListener('scroll', handleScroll)
        handleScroll()

        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [location.pathname, network.name, isMobile])

    return (
        <Navbar fixed='top' className='box header' container={false}>
            <Container>
                <NavbarBrand href={`/${network.name}`}>
                    <img
                        src={
                            'https://res.cloudinary.com/dwcf5cmei/image/upload/v1736822148/vbchain/vbchainFullWhiteVersion.png'
                        }
                        className='header-logo'
                        alt='VBChain Logo'
                    />
                </NavbarBrand>
                {isMobile ? (
                    <div className='mobile-nav'>
                        <MobileMenu />
                    </div>
                ) : (
                    <div className='header-nav-group'>
                        {showSearch && <SearchBox />}
                        <HeaderDropdown title='Blockchain' />
                        <HeaderDropdown title='Lookup' />
                        <HeaderDropdown title='Tools' />
                        {isBlockchain_2 && (
                            <div
                                onClick={() =>
                                    location.pathname.includes('/beacon')
                                        ? history.push(`/${network.name}`)
                                        : history.push(`/${network.name}/beacon`)
                                }
                                style={{
                                    padding: '8px 16px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    fontSize: '14px',
                                    backgroundColor: 'var(--dropdown-background)',
                                    borderRadius: '20px',
                                    transition: 'background-color 0.2s'
                                }}
                            >
                                <span
                                    className={`${network.name}-text-color-after cursor-pointer`}
                                    style={{ lineHeight: '24px' }}
                                >
                                    {location.pathname.includes('/beacon') ? 'Home' : 'Beacon'}
                                </span>
                            </div>
                        )}
                        <HeaderDropdownNetworks />
                    </div>
                )}
            </Container>
        </Navbar>
    )
}

module.exports = { Header }
